<template>
  <ion-buttons class="form-block-buttons">
    <ion-button v-if="registrationEnabled" size="small" fill="clear" color="dark" @click="goToRegistration()">
      {{ $t('auth.logIn.linkToRegister') }}
    </ion-button>

    <ion-button id="popover-trigger" size="small" fill="clear" color="dark">
      {{ $t('auth.logIn.linkToPasswordRestore') }}
    </ion-button>
  </ion-buttons>

  <ion-buttons class="form-block-buttons center">
    <ion-button size="small" fill="clear" color="dark" @click="pagePrivacyPolicy(link)">
      {{ $t('privacyPolicy') }}
    </ion-button>
    <ion-button size="small" fill="clear" color="dark" @click.stop="showAppInfo()">
      <ion-label v-if="!isLoading">
        {{ $t('appMenu.aboutApp') }}
      </ion-label>
    </ion-button>
  </ion-buttons>

  <ion-popover
    trigger="popover-trigger"
    trigger-action="click"
    :show-backdrop="false"
    alignment="end"
    dismiss-on-select
  >
    <ion-list mode="md">
      <ion-item lines="none" button @click="openPasswordRestoreModal(pageRef)">
        {{ $t('auth.signUp.resetPassword') }}
      </ion-item>
      <ion-item button lines="none" @click="openSupportModal(pageRef)">
        {{ $t('auth.logIn.linkToSupport') }}
      </ion-item>
    </ion-list>
  </ion-popover>
</template>

<script lang="ts" setup>
import { IonButton, IonButtons, IonLabel, IonPopover, IonList, IonItem } from '@ionic/vue';
import type { ComponentPublicInstance, ComputedRef, PropType } from 'vue';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { openPasswordRestoreModal, openSupportModal, pagePrivacyPolicy, useSettings, useSession } from '@/helpers';
import { ROUTES_NAME } from '@/router';
import { useAppStore, useNetworkStore, useUserStore } from '@/store';

// Props
defineProps({
  pageRef: {
    type: [Object, null] as PropType<ComponentPublicInstance | null>,
    required: true,
  },
});

// Router
const router = useRouter();

// Store
const appStore = useAppStore();
const networkStore = useNetworkStore();
const userStore = useUserStore();

// Helpers
const settingsHelper = useSettings();

// Variables
const link = import.meta.env.VITE_APP_AGB;
const registrationEnabled = useSession().registrationEnabled;

// Computed
const isLoading: ComputedRef<boolean> = computed(
  () => appStore.isLoading || networkStore.isLoading || userStore.isLoading
);

// Methods
const goToRegistration = async () => {
  await router.push({ name: ROUTES_NAME.REGISTRATION });
};

const showAppInfo = async () => {
  try {
    await settingsHelper.showAppInfo();
  } catch (e) {
    console.error('[ERROR] Error in showAppInfo:', e);
  }
};
</script>

<style scoped lang="scss">
.form-block {
  padding: app-padding(lg);
  border-radius: #{app-radius(md)};

  ion-button {
    margin-top: 1rem;
  }

  &-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: app-padding(lg);
    flex-wrap: wrap;
    text-align: center;

    ion-button {
      text-transform: none;
      --border-radius: #{app-radius(md)};
      margin: 0;
    }

    &.center {
      justify-content: center;
    }
  }
}
</style>
